export default {
  init() {
    // JavaScript to be fired on all pages
    console.log('init templateFlipbook');
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    console.log('finalize templateFlipbook');
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateFlipbook.js